/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import {getElementTop} from '@dvrd/dvr-controls';
import {ImageSizes} from "./interfaces";

export const getImg = (imgName: string, fallbackExtension: string = 'png'): string => {
    const webpSupported = webpIsSupported(), extension = webpSupported ? 'webp' : fallbackExtension;
    try {
        return require(`../../res/img/${imgName}.${extension}`);
    } catch {
        return require(`../../res/img/${imgName}.${fallbackExtension}`);
    }
};

const webpIsSupported = (): boolean => {
    try {
        return document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0;
    } catch {
        return false
    }
}

export const createErrorMessage = (message: string): string =>
    `${message} Probeer het later opnieuw of neem contact met mij op.`;

export const getHeaderHeight = (): number => {
    const header = document.getElementById('app-header');
    if (header) {
        return header.getBoundingClientRect().height;
    }
    return 0;
};

export const pageScroller = (id: string) => {
    if (!id.length) window.scroll({top: 0, behavior: "smooth"});
    const element = document.getElementById(id);
    if (element) {
        const top = getElementTop(element);
        window.scroll({top: top - getHeaderHeight() + 1, behavior: 'smooth'});
    }
};

export function getImgSources(source: string, sizes: Array<number>) {
    const imgName = `${source}-x`;
    const sources: Array<string> = sizes.map((size: number) => `${getImg(imgName + size)} ${size}w`);
    return sources.join(',');
}

export function getImgSizes(sizes: Array<number>, fallback: number = 960): string {
    const pageSizes = ['599', '959', '1279'];
    const imageSizes: Record<string, number> = {};
    for (let i = 0; i < pageSizes.length; i++) {
        const pageSize = pageSizes[i];
        imageSizes[pageSize] = i >= sizes.length ? fallback : sizes[i];
    }
    return createImageSizes(imageSizes, fallback);
}

export const createImageSizes = (sizes: ImageSizes, fallback: number): string => {
    const imageSizes: string[] = [];
    for (const key of Object.keys(sizes))
        imageSizes.push(`(max-width: ${key}px) ${sizes[key]}px`);
    return imageSizes.join(', ') + `, ${fallback}px`;
};